import { store } from '@wordpress/interactivity';

const KEY = 'ndg_consent';
const MAX_AGE_MS = 13 * 30 * 24 * 60 * 60 * 1000; // ~13 mois (CNIL)

const persist = (state) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      analytics: !!state.analytics,
      ads: !!state.ads,
      date: new Date().toISOString(),
    }));
  } catch (e) {}
};

const updateConsentMode = (state) => {
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', {
      ad_storage: state.ads ? 'granted' : 'denied',
      ad_user_data: state.ads ? 'granted' : 'denied',
      ad_personalization: state.ads ? 'granted' : 'denied',
      analytics_storage: state.analytics ? 'granted' : 'denied',
    });
  }
};

const syncGlobal = (state) => {
  window.__ndgConsent = { analytics: state.analytics, ads: state.ads };
  document.dispatchEvent(new CustomEvent('ndg:consent', {
    detail: { analytics: state.analytics, ads: state.ads },
  }));
};

// Activation des iframes gatées côté PHP (placeholders .ndg-consent-gate)
const activateGatedEmbeds = () => {
  document.querySelectorAll('.ndg-consent-gate:not(.is-loaded)').forEach((gate) => {
    const src   = gate.dataset.consentSrc;
    const allow = gate.dataset.consentAllow || '';
    const title = gate.dataset.consentTitle || '';
    if (!src) return;

    const iframe = document.createElement('iframe');
    iframe.src = src;
    if (allow) iframe.allow = allow;
    if (title) iframe.title = title;
    iframe.allowFullscreen = true;
    iframe.frameBorder = '0';
    iframe.loading = 'lazy';

    gate.appendChild(iframe);
    gate.classList.add('is-loaded');
  });
};

const loadSaved = () => {
  try {
    const old = localStorage.getItem('da_consent_v2');
    if (old) {
      localStorage.setItem(KEY, old);
      localStorage.removeItem('da_consent_v2');
    }
  } catch (e) {}

  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;

    const saved = JSON.parse(raw);
    if (saved.date && Date.now() - new Date(saved.date).getTime() > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return saved;
  } catch (e) {
    return null;
  }
};

// Lu dès le chargement : le bandeau est visible dès le HTML, l'état initial
// doit donc être juste à l'hydratation (sinon masqué puis réaffiché).
const savedAtLoad = loadSaved();

const { state } = store('ndg/consent', {
  state: {
    bannerVisible: !savedAtLoad,
    panelOpen: false,
    analytics: false,
    ads: false,
  },
  actions: {
    init() {
      // Lien #cookiesBanner → ouvre la bannière
      document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href="#cookiesBanner"]');
        if (link) {
          e.preventDefault();
          state.bannerVisible = true;
          state.panelOpen = true;
        }
      });

      // Bouton "Accepter et afficher" sur les placeholders
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.ndg-consent-gate__btn');
        if (btn) {
          e.preventDefault();
          state.analytics = true;
          state.ads = true;
          persist(state);
          updateConsentMode(state);
          syncGlobal(state);
          activateGatedEmbeds();
          state.bannerVisible = false;
          state.panelOpen = false;
        }
      });

      const saved = savedAtLoad;
      if (!saved) {
        state.bannerVisible = true;
        syncGlobal(state);
        return;
      }
      state.analytics = !!saved.analytics;
      state.ads = !!saved.ads;
      updateConsentMode(state);
      syncGlobal(state);

      if (state.analytics) {
        activateGatedEmbeds();
      }
    },
    acceptAll() {
      state.analytics = true;
      state.ads = true;
      persist(state);
      updateConsentMode(state);
      syncGlobal(state);
      activateGatedEmbeds();
      state.bannerVisible = false;
      state.panelOpen = false;
    },
    declineAll() {
      state.analytics = false;
      state.ads = false;
      persist(state);
      updateConsentMode(state);
      syncGlobal(state);
      state.bannerVisible = false;
      state.panelOpen = false;
    },
    togglePanel() {
      state.panelOpen = !state.panelOpen;
    },
    toggleBanner(event) {
      event.preventDefault();
      state.bannerVisible = !state.bannerVisible;
    },
    setAnalytics({ event }) {
      state.analytics = !!event?.target?.checked;
      persist(state);
      updateConsentMode(state);
      syncGlobal(state);
      if (state.analytics) activateGatedEmbeds();
    },
    setAds({ event }) {
      state.ads = !!event?.target?.checked;
      persist(state);
      updateConsentMode(state);
      syncGlobal(state);
    },
    save() {
      persist(state);
      updateConsentMode(state);
      syncGlobal(state);
      if (state.analytics) activateGatedEmbeds();
      state.bannerVisible = false;
      state.panelOpen = false;
    },
    openManager() {
      state.bannerVisible = true;
      state.panelOpen = true;
    },
  },
});
